import type { ReactElement } from "react";
import { AuthForm } from "./AuthForm";

type SignupFormProps = {
	onSuccess?: () => void;
	loginUrl?: string;
};

export function SignupForm({
	onSuccess,
	loginUrl = "/login",
}: SignupFormProps): ReactElement {
	return (
		<AuthForm mode="signup" onSuccess={onSuccess} switchUrl={loginUrl} />
	);
}
